import {useEffect} from 'react';
import {useQueryClient, useMutation} from "react-query";
import {useFormik} from "formik";
import useUser from "../useUser";
import api from "../../services/api";

const updateUserMutation = (data) => {
    console.log(data);
    const formData = new FormData();
    for (const key in data) {
        if(key === 'avatar') {
            if(data?.avatar instanceof File || data?.avatar === false) {
                formData.append('avatar', data.avatar ? data.avatar : '');
            }
        }
        else {
            formData.append(key, data[key]);
        }
    }

    return api.post('/users/self', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }).then(response => response?.data?.data);
};

const useUpdateUser = (config = {}) => {
    const queryClient = useQueryClient();
    const user = useUser();

    const mutation = useMutation(updateUserMutation, {
        ...config,
        onSuccess: (data) => {
            formik.resetForm(); // Since we're updating, we dont need this

            // Update query data on react-query
            queryClient.setQueryData('user', data);

            if(config?.onSuccess) {
                config.onSuccess(data);
            }

            return true;
        },
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            name: user?.name || '',
            company: user?.company || '',
            location: user?.location || '',
            remarks: user?.remarks || '',
            avatar: user?.avatar || false,
        },
        onSubmit: mutation.mutateAsync,
    });

    return {
        formik,
        mutation,
    };
};

export default useUpdateUser;
